import type { Branding } from '@logto/schemas';

/**
 * When Logto branding is hidden, show a partner footer if both label and link are set.
 */
export function hasPartnerFooterBranding(branding: Branding | undefined): boolean {
  return Boolean(branding?.partnerPoweredByLabel?.trim() && branding.partnerWebsiteUrl?.trim());
}
